import * as Redux from 'redux';
import { ReduxAction, SimpleResponse } from '../app/app.types';
import { PosState, PosActionTypes, PosEntity, PosRegistrationResponse } from './Types';
import { 
  INITIAL_STATE, 
  REGISTER_POS, 
  GET_POS_HISTORIES, 
  ROW_CLICKED, 
  GET_PREDEFINED_ITEMS,
  CREATE_PREDEFINED_ITEM,
  UPDATE_PREDEFINED_ITEM,
  DELETE_PREDEFINED_ITEM,
  REFUND_POS
} from './Constants';

const posReducer: Redux.Reducer<PosState> = 
  (posState: PosState = INITIAL_STATE,
   action: ReduxAction<PosActionTypes, SimpleResponse<PosEntity>>): PosState => {
  switch (action.type) {
    case `${GET_PREDEFINED_ITEMS}_FULFILLED`:
      return {
        ...posState,
        statusCode: action.payload.statusCode,
        predefinedItems: action.payload.body.list
      };
    case `${CREATE_PREDEFINED_ITEM}_FULFILLED`:
      return {
        ...posState,
        statusCode: action.payload.statusCode,
        predefinedItems: [...posState.predefinedItems, action.payload.body.entity]
      };
    case `${UPDATE_PREDEFINED_ITEM}_FULFILLED`:
      return {
        ...posState,
        statusCode: action.payload.statusCode,
        predefinedItems: [
          ...posState.predefinedItems.slice(
            0, 
            posState.predefinedItems.map((p: PosRegistrationResponse) => p.id).indexOf(action.payload.body.entity.id)
          ),
          action.payload.body.entity,
          ...posState.predefinedItems.slice( 
            posState.predefinedItems.map((p: PosRegistrationResponse) => p.id)
            .indexOf(action.payload.body.entity.id) + 1
          )
        ]
      };
    case `${DELETE_PREDEFINED_ITEM}_FULFILLED`:
      return {
        ...posState,
        statusCode: action.payload.statusCode,
        predefinedItems: [
          ...posState.predefinedItems.slice(
            0, 
            posState.predefinedItems.map((p: PosRegistrationResponse) => p.id).indexOf(action.payload.body.entity.id)
          ),
          ...posState.predefinedItems.slice( 
            posState.predefinedItems.map((p: PosRegistrationResponse) => p.id)
            .indexOf(action.payload.body.entity.id) + 1
          )
        ]
      };
    case `${REGISTER_POS}_FULFILLED`:
      return { ...posState,
        statusCode: action.payload.statusCode,
        sale: action.payload.body.entity
      };
    case `${REFUND_POS}_FULFILLED`:
      return { ...posState,
        statusCode: action.payload.statusCode,
        sale: action.payload.body.entity
      };
    case `${GET_POS_HISTORIES}_FULFILLED`:
      return {
        ...posState,
        statusCode: action.payload.statusCode,
        histories: action.payload.body.list
      };
    case `${ROW_CLICKED}`:
      return {
        ...posState,
        sale: action.payload.body.entity
      };
    default:
      return posState;
  }
};

export default posReducer;



// WEBPACK FOOTER //
// ./src/pos/Reducer.tsx